var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.352 -0.187)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.352 0.187)",
    fill: "none",
    stroke: "#e52431",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 29.5,
    rx: 30,
    ry: 29.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 29.5,
    rx: 28.5,
    ry: 28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.066,2.25A10.244,10.244,0,0,0,6.75,12.359c0,7.582,10.316,18.775,10.316,18.775S27.381,19.941,27.381,12.359A10.244,10.244,0,0,0,17.066,2.25Zm0,13.72a3.611,3.611,0,1,1,3.684-3.61A3.613,3.613,0,0,1,17.066,15.97Z",
    transform: "translate(13.055 12.959)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.3a1ed67d287618915f792fdabb22a7ea.svg";
export { ForwardRef as ReactComponent };